import { render, staticRenderFns } from "./AS_AmicableForm.vue?vue&type=template&id=a876e6e4&scoped=true&"
import script from "./AS_AmicableForm.vue?vue&type=script&lang=js&"
export * from "./AS_AmicableForm.vue?vue&type=script&lang=js&"
import style0 from "./AS_AmicableForm.vue?vue&type=style&index=0&id=a876e6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a876e6e4",
  null
  
)

export default component.exports